import * as questionGroupComponents from '@ignitesales/neuro-application/src/components/questions/containers/index.mjs';
import CalculatedGroup from './CalculatedGroup.jsx';
import SubGroup from './SubGroup.jsx';

export default {
  ...questionGroupComponents,
  CalculatedGroup,
  SubGroup
};
